import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from './routes';

/**
 * Scrolls to the section a route maps to, so visiting a real URL
 * (e.g. /calculator) looks identical to clicking the old #calculator anchor.
 * No-op during SSR/prerender (effect only runs in the browser).
 */
export default function ScrollToSection() {
  const { pathname } = useLocation();
  useEffect(() => {
    const sectionId = ROUTES.find((r) => r.path === pathname)?.sectionId ?? 'top';
    if (sectionId === 'top') {
      window.scrollTo({ top: 0 });
      return;
    }
    document.getElementById(sectionId)?.scrollIntoView();
  }, [pathname]);
  return null;
}
